import { ofType, StateObservable } from 'redux-observable';
import { forkJoin, Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { Dependencies } from '../../../../store';
import { PayloadAction } from '../../../../store.model';
import { Category, Item } from '../../core';
import { ApiService } from '../../core/api.service';
import { ActionType } from '../event-centre-dialog.action';
import { EventCentreDialogState } from '../event-centre-dialog.state';

import { Reload, reloadResult } from './reload.action';

export const reloadEpic = (
    action: Observable<PayloadAction<ActionType, Reload>>,
    state: StateObservable<any>,
    deps: Dependencies,
): Observable<ActionType> =>
    action.pipe(
        ofType(ActionType.NOTI__EC__RELOAD),
        switchMap((act: PayloadAction<ActionType, Reload>) => {
            const rootState = state.value?.notification
                ?.eventCentre as EventCentreDialogState;
            const service = deps.injector.get<ApiService>(ApiService);

            return forkJoin([
                act.payload.hard === 'reload'
                    ? service.listCategories(act.payload.userId)
                    : of(null),
                service.listItems(
                    act.payload.userId,
                    rootState?.filterOpts?.dateRange?.from,
                    rootState?.filterOpts?.dateRange?.to,
                ),
            ]).pipe(
                map((ret: [Category[], Item[]]) => {
                    return reloadResult(
                        {
                            ...act.payload,
                            categories: ret[0],
                            items: ret[1],
                        },
                        act.storePath,
                    );
                }),
                catchError((err) => {
                    console.log(err);
                    return of(null);
                }),
            );
        }),
    );
